import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import './BannerTest.css';

// Constants
const MOROCCAN_CATEGORIES = [
        { 
            id: 1, 
            name: 'Khalie',
            products: ['Khalie Premium', 'Khalie Traditionnel', 'Khalie Bio', 'Khalie Extra']
        },
        { 
            id: 2, 
            name: 'Gâteaux Traditionnels',
            products: ['Ghoriba', 'Fekkas', 'Makrout', 'Kaab Ghzal']
        },
        { 
            id: 3, 
            name: 'Prestige',
            products: ['Selection Prestige', 'Pack Premium', 'Edition Spéciale', 'Coffret Luxe']
        },
        { 
            id: 4, 
            name: 'Les Salés',
            products: ['Briwate Salé', 'Pastilla', 'Msemmen', 'Harcha']
        },
        { 
            id: 5, 
            name: 'Petits Salés',
            products: ['Mini Briwate', 'Bouchées Salées', 'Mini Pastilla', 'Petits Feuilletés']
        },
        { 
            id: 6, 
            name: 'Les Amandes',
            products: ['Amandes Nature', 'Amandes Grillées', 'Amandes Pralinées', 'Amandes Chocolat']
        },
        { 
            id: 7, 
            name: 'Petits Sucrés',
            products: ['Mini Ghoriba', 'Petits Gâteaux', 'Bouchées Sucrées', 'Mini Kaab Ghzal']
        },
        { 
            id: 8, 
            name: 'Ramadanesque',
            products: ['Chebakia', 'Sellou', 'Briwate Miel', 'Griwech']
        },
        { 
            id: 9, 
            name: 'Traiteur Surgelé',
            products: ['Pastilla Surgelée', 'Briwate à Cuire', 'Plats Préparés', 'Tajines']
        },
        { 
            id: 10, 
            name: 'Boulangerie',
            products: ['Khobz', 'Pain Maison', 'Batbout', 'Mlawi']
        },
        { 
            id: 11, 
            name: 'Nougat et Chocolat',
            products: ['Nougat Artisanal', 'Chocolat Maison', 'Pralines', 'Truffes']
        },
        { 
            id: 12, 
            name: 'Autres',
            products: ['Spécialités', 'Nouveautés', 'Produits Saisonniers', 'Assortiments']
        },
        { 
            id: 13, 
            name: 'Huiles',
            products: ['Huile d\'Olive', 'Huile d\'Argan', 'Huile de Cactus', 'Huile de Nigelle']
        },
        { 
            id: 14, 
            name: 'Amlou',
            products: ['Amlou Traditionnel', 'Amlou Bio', 'Amlou Extra', 'Amlou Amandes']
        },
];

const ORBIT_IMAGES = [
    'feature-img1.png',
    'feature-img3.png',
    'feature-img4.png',
    'feature-img5.png',
    'feature-img6.png',
    'feature-img7.png',
    'feature-img4.png',
    'feature-img7.png',
    'feature-img3.png',
    'feature-img5.png',
];

const SLIDER_SETTINGS = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
};

const BANNER_SLIDES = [
    {
        subtitle: 'Tradition Fassi Authentique',
        title: 'Le Goût du Terroir Marocain',
        buttonText: 'Découvrir',
    },
    {
        subtitle: 'Qualité Premium & Savoir-Faire Artisanal',
        title: 'Savourez les Trésors de la Gastronomie Fassi',
        buttonText: 'Commander',
    },
];

const BannerTest = () => {
    const [activeIndexCat, setActiveIndexCat] = useState(null);

    const handleCatClick = (index) => {
        setActiveIndexCat(activeIndexCat === index ? null : index);
    };

    const orbitItems = useMemo(() => 
        ORBIT_IMAGES.map((img, index) => ({
            id: index,
            src: `assets/images/thumbs/${img}`,
            alt: `Product ${index + 1}`,
            orbitIndex: index,
        })), []
    );

    return (
        <div className="banner-two">
            <div className="container container-lg">
                <div className="banner-two-wrapper d-flex align-items-start">
                    <div className="w-265 d-lg-block d-none flex-shrink-0">
                        <div className="responsive-dropdown style-two common-dropdown nav-submenu p-0 submenus-submenu-wrapper shadow-none border border-gray-100 position-relative border-top-0">
                            <button
                                type="button"
                                className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
                            >
                                <i className="ph ph-x" />{" "}
                            </button>
                            <div className="logo px-16 d-lg-none d-block">
                                <Link to="/" className="link">
                                    <img src="assets/images/logo/logo.png" alt="Logo" />
                                </Link>
                            </div>
                            <ul className="responsive-dropdown__list scroll-sm p-0 py-8 overflow-y-auto">
                                {MOROCCAN_CATEGORIES.map((category, index) => (
                                    <li 
                                        key={category.id} 
                                        className="has-submenus-submenu" 
                                        onClick={() => handleCatClick(index)}
                                    >
                                        <Link
                                            to="#"
                                            className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                                        >
                                            <span>{category.name}</span>
                                            <span className="icon text-md d-flex ms-auto">
                                                <i className="ph ph-caret-right" />
                                            </span>
                                        </Link>
                                        <div className={`submenus-submenu py-16 ${activeIndexCat === index ? "open" : ""}`}>
                                            <h6 className="text-lg px-16 submenus-submenu__title">
                                                {category.name}
                                            </h6>
                                            <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                                {category.products.map((product, idx) => (
                                                    <li key={idx}>
                                                        <Link to="/shop">{product}</Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div 
                        className="banner-item-two-wrapper rounded-24 overflow-hidden position-relative arrow-center flex-grow-1 mb-0"
                        style={{ background: 'linear-gradient(65deg, darkgoldenrod, lightgoldenrodyellow)' }}
                    >
                        <div className="banner-item-two__slider">
                            <Slider {...SLIDER_SETTINGS}>
                                {BANNER_SLIDES.map((slide, index) => (
                                    <div key={index} className="banner-item-two">
                                        <div className="banner-item-two__content">
                                            <span className="text-white mb-8 h6">{slide.subtitle}</span>
                                            <h2 className="banner-item-two__title bounce text-white">
                                                {slide.title}
                                            </h2>
                                            <Link
                                                to="/shop"
                                                className="btn btn-outline-white d-inline-flex align-items-center rounded-pill gap-8 mt-48"
                                            >
                                                {slide.buttonText}
                                                <span className="icon text-xl d-flex">
                                                    <i className="ph ph-shopping-cart-simple" />
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>

                        {/* Central Character Image */}
                        <div className="central-character">
                            <img 
                                src="assets/images/thumbs/idea.png" 
                                alt="Character" 
                                className="character-img"
                            />
                        </div>

                        {/* Orbit Path (Dashed Circle) */}
                        <div className="orbit-path"></div>

                        {/* Orbiting Images */}
                        <div className="orbit-container">
                            {orbitItems.map((item) => (
                                <div 
                                    key={item.id}
                                    className="orbit-item"
                                    style={{
                                        '--orbit-index': item.orbitIndex,
                                        '--total-items': ORBIT_IMAGES.length
                                    }}
                                >
                                    <div className="orbit-image-wrapper">
                                        <img 
                                            src={item.src}
                                            alt={item.alt}
                                            className="orbit-image"
                                            loading="lazy"
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BannerTest;

